
import { Component, Mixins } from "vue-property-decorator";
import { IRangeOfMotionBehavior, RangeOfMotionBehavior } from "../../../../../../documaker/domain/format/objects";
import { IRangeOfMotionBehaviorPropertyEditable, instanceOfIRangeOfMotionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class RangeOfMotionBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRangeOfMotionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRangeOfMotionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isRangeOfMotionBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIRangeOfMotionBehaviorPropertyEditable(s) && s.rangeOfMotionBehavior().isEditable(), false);
  }

  get rangeOfMotionBehavior(): IRangeOfMotionBehavior {
    return this.readPropertyOrDefault(s => s.rangeOfMotionBehavior().getValue(), new RangeOfMotionBehavior());
  }

  set rangeOfMotionBehavior(value: IRangeOfMotionBehavior) {
    this.writePropertyWhenValid(s => s.rangeOfMotionBehavior().setValue(value));
  }
}
